import actions from '../../actionTypes';

export default location => {
  return {
    type: actions.DELETE_LOCATION,
    location
  };
};



// WEBPACK FOOTER //
// ./src/reducers/locations/actions/deleteLocation.js